import React, { Component } from 'react';
import Select from 'react-select';
import smoothscroll from 'smoothscroll-polyfill';
import 'whatwg-fetch';
import Loader from './Loader';
import './Suggestions.css';
// kick off the polyfill!
smoothscroll.polyfill();

class Suggestions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tree: props.suggestions ? this.normalize(props.suggestions) : [],
            currentPath: [],
            currentQuerying: [],
            querying: props.suggestions ? false : true,
            hidden: false,
            lastChoice: -1,
            openMenu: false,
            opened: false,
            shouldOpenMenu: true,
            hideLastChoice: false
        };
        this.popStatus = this.popStatus.bind(this);
        this.resetStatus = this.resetStatus.bind(this);
        this.seleziona = {
            "cn": "选择",
            "de": "Wählen",
            "en": "Select",
            "es": "Seleccionar",
            "fr": "Sélectionner",
            "it": "Seleziona",
            "jp": "選択する",
            "ru": "Выбрать"
        };
        this.indietro = {
            "cn": "背部",
            "de": "Zurück",
            "en": "Back",
            "es": "Espalda",
            "fr": "Retour",
            "it": "Indietro",
            "jp": "バック",
            "ru": "назад"
        };
    }
    normalize(nodes) {
        return nodes.map(el => ({ ...el, ...(el.nodes ? { nodes: this.normalize(el.nodes), hasChildren: true } : {}) }));
    }

    componentDidMount() {
        if (typeof this.props.suggestions !== 'object') {
            setTimeout(() => {
                this.fetchSuggestions(this.props.onFirstLoadComplete)
            }, process.env.NODE_ENV === 'development' ? 500 : 0);
        }
    }

    async fetchLabelTranslation(data) {
        if (typeof data.label !== 'undefined') {
            let translatedLabel = await fetch(`translateLabel/${this.props.locale}/${data.label}`, { method: 'GET' });
            translatedLabel = await translatedLabel.json();
            data.label = translatedLabel.label;
        }

        return data.label;
    }

    async fetchSuggestions(callback) {
        const self = this;
        if (!this.props.suggestions) {
            const timeoutId = setTimeout(() => {
                this.setState({
                    querying: true,
                    openMenu: false,
                    opened: false,
                });
            }, 300);
            this.setState({
                tree: []
            });
            let data = await fetch(`suggestions/${this.props.wizard || ''}/${this.props.locale}/${this.state.currentPath.join(",")}`, { method: 'GET' });
            try {
                data = await data.json();
            } catch (Error) {
                console.log("wait for it....");
                await new Promise(resolve => setTimeout(resolve, 1000));

                return this.fetchSuggestions(callback);
            }
            await this.isShowAsSelect();

            await Promise.all(data.data)
                .then((translatedTree) => {
                    self.setState(
                        {
                            tree: translatedTree,
                            label: data.label,
                            currentPath: data.currentPath,
                            querying: false
                        },
                        () => {
                            callback && callback();
                        }
                    );
                })
            clearTimeout(timeoutId);
        }
    }

    pushNewStatus(index) {
        if (this.state.querying) {
            return;
        };

        this.props.scrollToBottom();
        this.setState((oldState) => {
            oldState.currentQuerying.push(oldState.tree[index]);
            oldState.currentPath.push(index);
            oldState.showLeftArrow = false;
            oldState.lastChoice = -1;
            return oldState;
        }, this.fetchSuggestions);
    }

    popStatus() {
        if (this.state.querying) {
            return
        };

        this.props.scrollToBottom();
        this.setState((oldState) => {
            oldState.currentPath.pop()
            oldState.showLeftArrow = false;
            oldState.lastChoice = -1;
            oldState.currentQuerying.pop();
            // delete oldState.currentQuerying;
            return oldState;
        }, this.fetchSuggestions)
    }

    resetStatus() {
        if (this.state.querying) {
            return;
        }

        this.props.scrollToBottom();
        this.setState({ currentPath: [], showLeftArrow: false, lastChoice: -1 }, this.fetchSuggestions);
        this.props.resetStatus();
    }

    runQuestion(text, lastChoice, element) {

        this.setState({ showLeftArrow: false, hidden: this.props.oneshot === true, lastChoice })
        if (text) {
            this.props.handleSubmit(text, undefined, undefined, undefined, element, "wizard");
            // this.props.removeMe()
        }
        if ((element.response || element.action)) {
            this.props.handleOfflineResponse(element);
        }
    }
    async isShowAsSelect() {
        return await fetch(`suggestions/${(this.props.wizard || '')}/${this.props.locale}/` + this.state.currentPath.join(","), { method: 'GET' })
            .then(data => data.json())
            .then(data => {
                const { showAsSelect = false } = data
                this.setState({
                    showAsSelect,
                    hideLastChoice: false,
                });
            });
    }

    renderAsSelect(root, rootIndex) {
        const selectOptions = root.map((element, index) => {
            if (!element || element.enabled === false) {
                return null;
            } else {
                return {
                    value: index,
                    key: rootIndex + index,
                    label: element.label,
                }
            }
        });

        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                padding: '3vw 4vw',
                boxShadow: 'none',
                backgroundColor: state.isFocused ? "#999" : undefined,
                color: state.isFocused ? '#fff' : undefined,
            }),
            control: () => ({
                lineHeight: 1.1,
                padding: '3vw 4vw',
                margin: 0,
                boxShadow: 'none',
            }),
            indicatorsContainer: () => ({
                width: 12,
                height: 12,
                position: 'absolute',
                right: '5%',
                top: 'calc(50% - 6px)',
            }),
            dropdownIndicator: () => ({
                width: 12,
                height: 12,
            }),
        }
        this.state.opened === false && this.state.openMenu === false && setTimeout(() => this.setState({ openMenu: true, opened: true }), 250);

        setTimeout(() => window.$("#card_body").scrollTop(window.$("#card_body")[0].scrollHeight), 100);

        return <Select
            key={rootIndex}
            className="select"
            onChange={(evt) => {
                const element = root[(evt.value)];
                if (element.hasChildren) {
                    this.pushNewStatus(evt.value)
                } else {
                    this.runQuestion(element.question, undefined, element)
                }
            }}
            options={selectOptions}
            styles={customStyles}
            isSearchable={false}
            placeholder={this.seleziona[this.props.locale]}
            menuPlacement={'bottom'}
            maxMenuHeight={'50vh'}
            // maxMenuHeight={'none'}
            onMenuClose={() => { console.log(1); this.setState({ openMenu: false }) }}
            onMenuOpen={() => {
                this.setState({ openMenu: true });
                setTimeout(() => window.$("#card_body").scrollTop(window.$("#card_body")[0].scrollHeight), 100);
            }}
            menuIsOpen={this.state.openMenu === true}
            minMenuHeight={'10vh'}
            classNamePrefix="react-select"
            theme={(theme) => ({
                ...theme,
                borderRadius: 0,
                colors: {
                    ...theme.colors,
                    // highlight color when holding the mouse/touch over
                    primary50: "rgb(145, 145, 145)",
                },
            })}
        >
        </Select>
    }

    renderSuggestionChips(root, rootIndex) {
        return root.map((element, index) => (
            !element || element.enabled === false || (this.state.lastChoice === index && this.state.hideLastChoice === true) ? null :
                [<div
                    className={"suggestion_chip" + (this.state.label ? " child" : "") + (this.state.lastChoice === index ? ' active' : '')}
                    key={rootIndex + index}
                    onMouseDown={() => element.hasChildren ? this.pushNewStatus(index) : this.runQuestion(element.question, index, element)}>
                    <div>
                        <div>{element.label}</div>
                    </div>
                </div>])
        )
    }

    render() {
        let root = this.state.tree;

        if (this.props.suggestions) {
            this.state.currentPath.map(index => root = root[index].nodes)
        }

        const showAsSelect = this.state.showAsSelect;

        let rootIndex = this.state.currentPath.join(",") + ","
        const parentLabel = [
            this.state.label ?
                ([<div style={{ display: "table" }} key="parent" onClick={() => this.popStatus()} className="suggestion_chip parent">
                    <div style={{ display: "table-cell", verticalAlign: "middle", margin: "0 auto" }}><div>{this.state.label}</div></div>
                </div>]) : []];
        if (this.state.hidden === true) {
            return null;
        }

        return (
            <div style={{ position: "relative", marginTop: "20px" }}>
                <div ref="container" style={{ overflowX: "none", textAlign: "right" }}>
                    {this.state.querying ? [
                        this.state.currentQuerying.length > 0 ? this.renderSuggestionChips([this.state.currentQuerying[this.state.currentQuerying.length - 1]]) : null,
                        <Loader key="loader" />
                    ] : (
                            [
                                [
                                    ...parentLabel,
                                    showAsSelect ?
                                        this.renderAsSelect(root, rootIndex) :
                                        this.renderSuggestionChips(root, rootIndex)
                                ],
                                this.props.suggestions ? ([
                                    <div
                                        key="-2"
                                        className="suggestion_chip"
                                        onClick={this.popStatus}
                                    >
                                        {this.indietro[this.props.locale]}
                                    </div>
                                ]) : null
                            ]
                        )}
                    <span style={{ clear: "both" }} />
                </div>
            </div>
        );
    }
}

export default Suggestions;
